import React from 'react';

import { TwoColorGraph } from '~/components/lawns/digital-soil-test/common/generic-graphs';
import Tooltip from '~/components/tooltip/tooltip';

import styles from '~/components/lawns/digital-soil-test/digital-soil-test.module.scss';

const SoilPhGraph = ({ isSoilPhLimiting }) => (
  <div className={styles.graphContainer}>
    <h4 className={styles.graphTitle}>
      Soil pH{' '}
      <Tooltip content="Soil pH values characterize the chemical environment of the soil. A pH below 6 can limit availability of certain nutrients." />{' '}
    </h4>
    {isSoilPhLimiting && (
      <p className={styles.graphInfo}>
        Low pH can impact nutrient availability, might need to add lime to help
        raise it
      </p>
    )}
    <TwoColorGraph value={isSoilPhLimiting ? 'low' : 'high'} />
  </div>
);

export default SoilPhGraph;
